import { render, staticRenderFns } from "./binditems.vue?vue&type=template&id=099e3a5f&"
import script from "./binditems.vue?vue&type=script&lang=js&"
export * from "./binditems.vue?vue&type=script&lang=js&"
import style0 from "./binditems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports